<template>
  <div class="card">
    <header class="header-card">
      <p>{{ $t('ajoutEditContrat.produit.title')}}</p>
    </header>
    <div class="card-content">
      <div class="level" v-if="isViewAjout">
        <div class="level-left">
          <selecteur-action
              @handleAction="handleActions"
              :options='actions'
              :placeholder='$t("general.placeHolder.groupedAction")'
              :titleButton="'general.button.apply'"
              :elementsSelectionnes="hasSomethingSelected">
          </selecteur-action>
        </div>
        <div class="level-right">
          <button class="button is-primary"
                v-if="isViewAjout"
                @click="popUpAjoutProduit = true">
            {{ $t('ajoutEditContrat.produit.addProduit') }}
          </button>
        </div>
      </div>
      <v-client-table
        ref="produitTable"
        :data="produits"
        :columns="columns"
        :options="options">
        <template slot="selected" slot-scope="props" >
          <div class="has-check-centered has-text-centered">
            <qd-checkbox
                  v-if="props.row.selected !== undefined"
                  :value="props.row.selected"
                  @input="select(props.row)">
            </qd-checkbox>
          </div>
        </template>
        <template slot="produit.reference" slot-scope="props">
          <router-link-blank
              v-if="getRoutingReference(props.row)"
              v-bind="getRoutingReference(props.row)">
          </router-link-blank>
        </template>
        <template slot="produit.supportCommercial" slot-scope="props">
          {{ $t(getType(props.row)) }}
        </template>
        <template slot="produit.libelle" slot-scope="props">
          {{ props.row.produit.libelle }}
        </template>
        <template slot="delete" slot-scope="props">
          <a @click="deleteItems([props.row.id])">
                <b-icon
                  icon="delete-forever"
                  type='is-danger'>
                </b-icon>
              </a>
        </template>
      </v-client-table>
      <b-modal v-model="popUpAjoutProduit">
        <pop-up-ajout-produit-bail
            :title="$t('ajoutEditContrat.produit.title')"
            :contratProduits="produits"
            :societeId="contrat.societeId"
            @add="addItem"/>
      </b-modal>
    </div>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON, TEXTS,
} from '@/configuration/clientTableConf';
import { CATEGORIE_PRODUIT } from '@/configuration/catalogue/produitConf';
import popUpAjoutProduitBail from '@/components/baux/contrat/p_ajoutProduitBail';
import { columnsSplice } from '@/services/general/columns';
import { ACTION_DELETE } from '@/configuration/general/actionsConf';
import selecteurAction from '@/components/general/selecteurAction';
import routerLinkBlank from '@/components/general/routerLinkBlank';

export default {
  props: {
    contrat: {
      type: Object,
      required: true,
    },
    isViewAjout: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      popUpAjoutProduit: false,
      produits: [],
      actions: [
        { action: ACTION_DELETE, translation: 'ajoutEditContrat.actions.remove' },
      ],
    };
  },
  components: {
    popUpAjoutProduitBail,
    selecteurAction,
    routerLinkBlank,
  },
  computed: {
    columns() {
      const column = ['selected', 'produit.reference', 'produit.supportCommercial', 'produit.libelle', 'delete'];
      if (!this.isViewAjout) {
        columnsSplice(column, 'delete');
        columnsSplice(column, 'selected');
      }
      return column;
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          'produit.reference': this.$t('ajoutEditContrat.produit.tab.reference'),
          'produit.supportCommercial': this.$t('ajoutEditContrat.produit.tab.type'),
          'produit.libelle': this.$t('ajoutEditContrat.produit.tab.libelle'),
          delete: '',
          selected: (h) => {
            return h(
              'div', {
                attrs: {
                  class: 'pointer has-text-centered',
                },
                on: {
                  click: () => {
                    this.selectAll();
                  },
                },
              },
              [
                h('b-icon', {
                  attrs: {
                    icon: this.iconSelectTotal,
                  },
                }),
              ],
            );
          },
        },
        sortable: ['produit.reference', 'produit.libelle', 'produit.supportCommercial'],
        texts: texts,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
      };
    },
    hasSomethingSelected() {
      return this.produits.some(p => p.selected);
    },
    allSelected() {
      return this.produits.every(p => p.selected);
    },
    iconSelectTotal() {
      if (this.allSelected) {
        return 'checkbox-multiple-marked-outline';
      }
      return 'checkbox-multiple-blank-outline';
    },
  },
  methods: {
    selectAll() {
      this.produits = this.produits.map(p => { return { ...p, selected: !this.allSelected }; });
    },
    select(item) {
      const index = this.produits.findIndex(p => p.id === item.id);
      if (index < 0) return;
      item.selected = !item.selected;
      this.$set(this.produits, index, item);
    },
    deleteItems(ids) {
      if (!ids || !Array.isArray(ids)) return;
      ids.forEach(id => {
        const index = this.produits.findIndex(p => p.id === id);
        if (index < 0) return;
        this.produits.splice(index, 1);
      });
      this.contrat.contratsProduits = this.produits;
    },
    addItem(item) {
      item.selected = false;
      this.produits.push(item);
      this.contrat.contratsProduits = this.produits;
    },
    handleActions(action) {
      switch (action) {
        case ACTION_DELETE:
          this.deleteItems(this.produits.filter(p => p.selected).map(p => p.id));
          break;
        default:
          break;
      }
    },
    getType(row) {
      return CATEGORIE_PRODUIT.find(p => p.code === row.produit.supportCommercial.categorieVente)?.libelle ?? '';
    },
    getRoutingReference(row) {
      const categorie = CATEGORIE_PRODUIT
        .find(p => p.code === row.produit.supportCommercial.categorieVente);
      if (!categorie) return null;
      const routes = {
        message: row.produit.reference,
        to: {
          name: categorie.routeDetail,
          params: { id: row.produit.id },
        },
      };
      return routes;
    },
  },
  mounted() {
    this.produits = this.contrat.contratsProduits ?? [];
    this.produits.forEach(p => { p.selected = false; });
  },
};
</script>

<style>

</style>
